<template>
    <div>
        <template v-if="showRequirements">
            <w-span v-bind="spanProps">Password must be at least</w-span>
            <w-span
                v-bind="requirementsFormatted.minLength.class"
                v-if="requirementsFormatted.minLength.show"
            >
                {{requirementsFormatted.minLength.text}}
            </w-span>
            <template v-if="showContains">
                <w-span v-bind="spanProps">and contain</w-span>
                <w-span
                    v-bind="item.class"
                    v-for="(item, i) in containsItems"
                    :key="item.value"
                >
                    {{formatText(item.text, i)}}
                </w-span>
            </template>
        </template>
    </div>
</template>

<script>
    import WValidationMixin from '../../mixins/forms/w-validation-mixin'
    import WTypographyMixin from '../../mixins/w-typography-mixin'
    import WSpan from '../WSpan'
    import _ from 'underscore'

    /**
     * Element containing description of password rules,
     * rules that have been met are highlighted in the theme's success color.
     */
    export default {
        name: 'WPasswordRequirements',
        mixins: [WValidationMixin, WTypographyMixin],
        props: {
            /**
             * String password value, used to check validation
             */
            password: {
                type: String,
                default: ''
            },
            /**
             * Object containing password requirements
             */
            requirements: {
                type: Object,
                default: () => ({
                    minLength: 4,
                    minNumbers: 0,
                    minSymbols: 0,
                    minLowercase: 0,
                    minUppercase: 0
                })
            }
        },
        components: {WSpan},
        computed: {
            passwordOptions () {
                return this.requirements
            },
            spanProps () {
                const vm = this
                return {
                    color: vm.color,
                    fontSize: vm.fontSize,
                    fontWeight: vm.fontWeight,
                    transform: vm.transform,
                    italic: vm.italic
                }
            },
            requirementsText () {
                return {
                    minLength: v => `${v} ${v > 1 ? 'characters' : 'character'}`,
                    minNumbers: v => `${v} ${v > 1 ? 'numbers' : 'number'}`,
                    minSymbols: v => `${v} ${v > 1 ? 'symbols' : 'symbol'}`,
                    minLowercase: v => `${v} ${v > 1 ? 'lowercase letters' : 'lowercase letter'}`,
                    minUppercase: v => `${v} ${v > 1 ? 'uppercase letters' : 'uppercase letter'}`
                }
            },
            requirementsFormatted () {
                const vm = this
                return _.mapObject(vm.requirements, (val, key) => ({
                    value: key,
                    quantity: val,
                    show: val > 0,
                    text: vm.requirementsText[key](val),
                    class: {
                        ...vm.spanProps,
                        fontWeight: 'bold',
                        color: vm.validationRules.password[key](vm.password) === true ? 'success' : vm.color
                    }
                }))
            },
            showRequirements () {
                return _.some(this.requirementsFormatted, (obj) => obj.show)
            },
            containsItems () {
                let items = _.omit(this.requirementsFormatted, ['minLength'])
                return _.filter(items, (item) => item.show)
            },
            showContains () {
                return !_.isEmpty(this.containsItems)
            },
            formatText () {
                const vm = this
                return (val, index) => {
                    const lastItem = vm.containsItems.length === index +1
                    return `${val}${lastItem ? '.' : ','}`
                }
            }
        }
    }
</script>
